import { fetchData } from "@request";

export type GroupNotificationResponse = {
  description: string,
  group_type: string,
  id: string,
  telegram_chat_id: string
}

export type AllGroupNotificationsResponse = {
  settings: GroupNotificationResponse[]
}

export const getAllGroupNotificationApi = async () => {
  try {
    const response = await fetchData<AllGroupNotificationsResponse>({
      url: `api/v1/admin/group-notifications`
    });

    return response;
  } catch (error) {
    console.error("getAllGroupNotificationApi failed:", error);
    throw error;
  }
}

export const getGroupNotificationApi = async (group_type: string) => {
  try {
    const response = await fetchData<GroupNotificationResponse>({
      url: `api/v1/admin/group-notifications/${group_type}`
    });

    return response;
  } catch (error) {
    console.error("getGroupNotificationApi failed:", error);
    throw error;
  }
}

export type NotificationGroupRequest ={
  group_type: string;
  telegram_chat_id: string;
}

export const updateGroupNotificationApi = async (group_type: string, data: NotificationGroupRequest) => {
  try {
    const response = await fetchData<string>({
      url: `/api/v1/admin/group-notifications/${group_type}`,
      method: "PUT",
      data,
    });

    return response;
  } catch (error) {
    console.error("updateGroupNotificationApi failed:", error);
    throw error;
  }
};
